// CommonJS, zodat gatsby-node.js hem met require leest en de componenten met import.
const site = require("./site.json")

// "" | "/street" | "/nl" | "/nl/street"
function variantPrefix(language, edition) {
    language = language || site.defaultLanguage
    edition = edition || site.defaultEdition
    let prefix = ""
    if (language !== site.defaultLanguage) prefix += "/" + language
    if (edition !== site.defaultEdition) prefix += "/" + edition
    return prefix
}

// path begint met "/", bv. "/compositions/mozart-requiem/"
function variantPath(path, language, edition) {
    return variantPrefix(language, edition) + path
}

function absoluteUrl(path) {
    return site.siteUrl + path
}

// Omgekeerd: "/nl/street/compositions/x/" -> { language: "nl", edition: "street", path: "/compositions/x/" }
function parseVariantPath(fullPath) {
    const parts = fullPath.split("/").filter(Boolean)
    let language = site.defaultLanguage
    let edition = site.defaultEdition
    if (parts.length && parts[0] !== site.defaultLanguage && site.languages[parts[0]]) language = parts.shift()
    if (parts.length && parts[0] !== site.defaultEdition && site.editions[parts[0]]) edition = parts.shift()
    return { language, edition, path: "/" + parts.join("/") + (parts.length ? "/" : "") }
}

module.exports = { variantPrefix, variantPath, absoluteUrl, parseVariantPath }
